export const APP_NAME = 'AI Workhub';